export default __webpack_public_path__ + "static/media/cbMGavdj.bb8f3907.svg";